import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../../../themes/Colors";
import useWindowDimensions from "../../../../../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import {
  BaseButtons,
  LoadingPopUp,
  TextInputField,
} from "../../../../../../../common-components";

const CategoryPopUp = ({ setClose, companyInformation, auth, setCategory }) => {
  const { width, height } = useWindowDimensions();

  const [screenDisplay, setScreenDisplay] = useState("current");

  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [tagLink, seTagLink] = useState("");

  const [categoyrArray, setCategoryArray] = useState("");

  const [refresh, setRefresh] = useState(false);

  const [loading, setLoading] = useState(false);

  // get category info

  // create map and the slect category

  // craete new categoyr and esfresh

  const createNewCategory = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/catalogue/createCategory",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            BussinessId: companyInformation._id,
            BussinessName: companyInformation.companyName,
            createdOn: new Date().toLocaleString(),
            description: categoryDescription,
            tagLink: tagLink,
            createdBy: auth.firstName + " " + auth.lastName,
            categoryName: categoryName,
          }),
        }
      );

      const respnseData = await response.json();

      if (!respnseData.message) {
        setLoading(false);
        setRefresh(refresh ? false : true);
        setScreenDisplay("current");
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  const getCategories = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/catalogue/getCategories",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            bussinessId: companyInformation._id,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setCategoryArray(respnseData.categoryList);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (companyInformation) {
      setClose("current");
      getCategories();
    }
  }, [refresh, companyInformation]);
  return (
    <div
      style={{
        width: width - 212,
        height: "100%",
        backgroundColor: "#00000040",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        zIndex: 500,
      }}
    >
      <div
        style={{
          backgroundColor: colors.white,
          padding: 10,
          minWidth: 400,
          minHeight: 400,
          maxHeight: 500,
          maxWidth: 400,
          borderRadius: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div style={{ marginTop: 5, marginBottom: 10, width: "90%" }}>
          SELECT CATEGORY
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,

            borderWidth: 1,
            width: "90%",
            overflowY: "scroll",
            overflowX: "hidden",
            flexDirection: "column",
          }}
        >
          {screenDisplay === "new" ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TextInputField
                labelTitle={"CATEGORY NAME"}
                mini={true}
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
              <TextInputField
                labelTitle={"CATEGORY DESCRIPTION"}
                mini={true}
                value={categoryDescription}
                onChange={(e) => setCategoryDescription(e.target.value)}
              />
              <TextInputField
                labelTitle={"TAG LINK"}
                mini={true}
                value={tagLink}
                onChange={(e) => seTagLink(e.target.value)}
              />
              <div style={{ minHeight: 20 }} />
              <BaseButtons
                borderRadius={4}
                label={"SUBMIT"}
                onClick={() => createNewCategory()}
                backgroundColor={colors.primaryBlue}
                width={"80%"}
              />
            </div>
          ) : categoyrArray ? (
            categoyrArray.map((item, index) => {
              return (
                <div
                  style={{
                    width: "100%",
                    minHeight: 50,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BaseButtons
                    label={item.categoryName}
                    borderRadius={4}
                    width={"100%"}
                    backgroundColor={colors.secondaryDarkBlue}
                    onClick={() => {
                      setCategory(item);
                      setClose(false);
                    }}
                  />
                </div>
              );
            })
          ) : null}
        </div>
        <BaseButtons
          borderRadius={4}
          label={"CANCEL"}
          onClick={
            screenDisplay === "new"
              ? () => setScreenDisplay("current")
              : () => setClose(false)
          }
          backgroundColor={colors.orangeDark}
          width={"80%"}
        />
        <div style={{ position: "absolute", top: 10, right: 10 }}>
          <BaseButtons
            borderRadius={4}
            label={"NEW CATEGORY"}
            onClick={() => setScreenDisplay("new")}
            backgroundColor={colors.orangeDark}
            width={140}
            height={30}
          />
        </div>
        <LoadingPopUp display={loading} width={"100%"} />
      </div>
    </div>
  );
};

export default CategoryPopUp;
